import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ExtendedOrderCache } from '../cache/ExtendedOrderCache';

export function IsPreManifest({ Id, Status, Meta }: SmartSendItemApiModel) {
  return (
    Status !== 'Sold' &&
    Meta['ManifestId']?.Value &&
    ExtendedOrderCache.preManifestedOrderLineIds.find((x) => x.SmartSendId === Id)
  );
}
